import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { addMonths, endOfMonth, startOfMonth } from 'date-fns';
import { MatCardContent } from '@angular/material/card';
import { PayeeIconButtonComponent } from '../../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { MatIcon } from '@angular/material/icon';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeDatepickerComponent } from '../../../../shared/payee-form-fields/payee-datepicker/payee-datepicker.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
  imports: [
    MatCardContent,
    PayeeIconButtonComponent,
    MatIcon,
    PayeeFormFieldComponent,
    PayeeDatepickerComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class DateFilterComponent {
  @Input({ required: true }) dateFrom!: FormControl<Date | null>;
  @Input({ required: true }) dateTo!: FormControl<Date | null>;
  @Input({ required: true }) loading!: boolean;
  @Output() refresh = new EventEmitter<void>();

  async addMonth(n: number): Promise<void> {
    if (!this.dateFrom.value || !this.dateTo.value) {
      return;
    }

    this.dateFrom.setValue(startOfMonth(addMonths(this.dateFrom.value, n)));
    this.dateTo.setValue(endOfMonth(addMonths(this.dateTo.value, n)));
  }
}
